import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { pathnames, requestLogin, requestLogout } from '../../api';
import { AuthenticatedContextProvider } from '../../context/AuthenticatedContext';
import LoginCustomer from '../../models/data/LoginCustomer';

const AuthProvider: React.FunctionComponent = ({ children }) => {
  const history = useHistory();
  const [loginCustomer, setLoginCustomer] = useState<LoginCustomer | undefined>(
    undefined,
  );
  return (
    <AuthenticatedContextProvider
      value={{
        isAuthenticated: loginCustomer != null,
        loginCustomer,
        login: async (req) => {
          return requestLogin(
            history.createHref({ pathname: pathnames.login }),
            req,
          )
            .then((res) => {
              // ログイン成功
              setLoginCustomer(res.data);
              return res;
            })
            .catch((err) => {
              // ログイン失敗（200番台以外もココ）
              setLoginCustomer(undefined);
              throw err;
            });
        },
        logout: async () => {
          return requestLogout(
            history.createHref({ pathname: pathnames.logout }),
          )
            .then((res) => {
              // ログアウト成功
              setLoginCustomer(undefined);
              return res;
            })
            .catch((err) => {
              // ログアウト失敗 → 現状維持
              throw err;
            });
        },
      }}
    >
      {children}
    </AuthenticatedContextProvider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AuthProvider;
